import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import {
  createFeedback,
  getFeedbackList,
  updateFeedback,
  deleteFeedback,
  toggleFeedback,
  singleFeedback,
} from '../slices/feedback/feedbackSlice';
import { STATUS } from '../../utils/status';
import { FeedbackState } from '../interfaces/feedbackInterface';

const ExtraReducers = (builder: ActionReducerMapBuilder<FeedbackState>) => {
  builder
    .addCase(createFeedback.pending, (state) => {
      state.createFeedbackStatus = STATUS.PENDING;
      state.createFeedbackMessage = null;
    })
    .addCase(createFeedback.fulfilled, (state, action: PayloadAction<any>) => {
      state.createFeedbackStatus = STATUS.SUCESS;
      state.createFeedbackMessage = action.payload?.message || 'Created successfully';
      if (state.feedbacks && state.feedbacks.results) {
        state.feedbacks.results = [action.payload, ...state.feedbacks.results];
      }
    })
    .addCase(createFeedback.rejected, (state, action: any) => {
      state.createFeedbackStatus = STATUS.FAILED;
      state.createFeedbackMessage = action.payload?.message || 'An error occurred';
    })
    .addCase(getFeedbackList.pending, (state) => {
      state.getFeedbackStatus = STATUS.PENDING;
      state.getMessage = null;
    })
    .addCase(getFeedbackList.fulfilled, (state, action: PayloadAction<any>) => {
      state.getFeedbackStatus = STATUS.SUCESS;
      state.feedbacks = action.payload;
      state.getMessage = null;
    })
    .addCase(getFeedbackList.rejected, (state, action: any) => {
      state.getFeedbackStatus = STATUS.FAILED;
      state.getMessage = action.payload?.message || 'An error occurred';
    })
    .addCase(updateFeedback.pending, (state) => {
      state.updateFeedbackStatus = STATUS.PENDING;
      state.updateFeedbackMessage = null;
    })
    .addCase(updateFeedback.fulfilled, (state, action: PayloadAction<any>) => {
      const updated = action.payload;
      state.updateFeedbackStatus = STATUS.SUCESS;
      state.updateFeedbackMessage = action.payload?.message || 'Updated successfully';

      if (state.feedbacks && state.feedbacks.results) {
        state.feedbacks.results = state.feedbacks.results.map((f: any) =>
          f.id === updated.id ? { ...f, ...updated } : f
        );
      }
      if (state.feedbackRow && state.feedbackRow.id === updated.id) {
        state.feedbackRow = { ...state.feedbackRow, ...updated };
      }
    })
    .addCase(updateFeedback.rejected, (state, action: any) => {
      state.updateFeedbackStatus = STATUS.FAILED;
      state.updateFeedbackMessage = action.payload?.message || 'An error occurred';
    })
    .addCase(deleteFeedback.pending, (state) => {
      state.deleteFeedbackStatus = STATUS.PENDING;
      state.deleteFeedbackMessage = null;
    })
    .addCase(deleteFeedback.fulfilled, (state, action: PayloadAction<any>) => {
      const { id } = action.payload;
      state.deleteFeedbackStatus = STATUS.SUCESS;
      state.deleteFeedbackMessage = 'Deleted successfully';
      if (state.feedbacks && state.feedbacks.results) {
        state.feedbacks.results = state.feedbacks.results.filter((f: any) => f.id !== id);
        state.feedbacks.count = (state.feedbacks.count ?? 0) - 1;
      }
    })
    .addCase(deleteFeedback.rejected, (state, action: any) => {
      state.deleteFeedbackStatus = STATUS.FAILED;
      state.deleteFeedbackMessage = action.payload?.message || 'An error occurred';
    })
    .addCase(toggleFeedback.pending, (state) => {
      state.toggleFeedbackStatus = STATUS.PENDING;
      state.toggleFeedbackMessage = null;
    })
    .addCase(toggleFeedback.fulfilled, (state, action: PayloadAction<any>) => {
      const updated = action.payload;
      state.toggleFeedbackStatus = STATUS.SUCESS;
      state.toggleFeedbackMessage = action.payload?.message || 'Toggled successfully';
      if (state.feedbacks && state.feedbacks.results) {
        state.feedbacks.results = state.feedbacks.results.map((f: any) =>
          f.id === updated.id ? updated : f
        );
      }
    })
    .addCase(toggleFeedback.rejected, (state, action: any) => {
      state.toggleFeedbackStatus = STATUS.FAILED;
      state.toggleFeedbackMessage = action.payload?.message || 'An error occurred';
    })
    .addCase(singleFeedback.pending, (state) => {
      state.singleFeedbackStatus = STATUS.PENDING;
    })
    .addCase(singleFeedback.fulfilled, (state, action: PayloadAction<any>) => {
      state.singleFeedbackStatus = STATUS.SUCESS;
      state.feedbackRow = action.payload;
    })
    .addCase(singleFeedback.rejected, (state, action: any) => {
      state.singleFeedbackStatus = STATUS.FAILED;
      state.feedbackRow = null;
    });

};

export default ExtraReducers;
